import { createSlice } from '@reduxjs/toolkit';
import { Roles } from 'shared/constants/roles';
import { getPermissions } from 'shared/permissions/';
import { checkAuth } from './checkAuthThunk';

const initialState = {
  isAuthenticated: false,
  authChecked: false,
  role: null,
  SRETenant: null,
  myInfo: {},
  error: null,
  isLoading: false,
  permissions: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    loginSuccess(state) {
      state.isAuthenticated = true;
    },
    logoutSuccess() {
      return initialState;
    },
    getMyInfo: state => {
      state.isLoading = true;
      state.error = null;
    },
    getMyInfoSuccess: (state, action) => {
      state.isLoading = false;
      state.myInfo = action.payload;
    },
    getMyInfoFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setUserRole: (state, action) => {
      state.role = action.payload;
      state.permissions = getPermissions(action.payload);
    },
    setSRETenant: (state, action) => {
      state.SRETenant = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(checkAuth.fulfilled, (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.role = action.payload.role;
      state.authChecked = true;
      state.permissions = getPermissions(action.payload.role);
    });
    builder.addCase(checkAuth.rejected, state => {
      state.isAuthenticated = false;
      state.role = null;
      state.authChecked = true;
      state.permissions = {};
    });
  }
});

export const {
  requestStart,
  requestFailure,
  loginSuccess,
  logoutSuccess,
  getMyInfo,
  getMyInfoSuccess,
  getMyInfoFailure,
  setUserRole,
  setSRETenant
} = authSlice.actions;

export const selectIsAuthenticated = state => state.auth.isAuthenticated;
export const selectAuthChecked = state => state.auth.authChecked;
export const selectMyInfo = state => state.auth.myInfo;
export const selectRole = state => state.auth.role;
export const isSaasUserRole = state => state.auth.role === Roles.SAAS_ADMIN;
export const isTenantUserRole = state => state.auth.role === Roles.TENANT_ADMIN;
export const isSREUserRole = state => state.auth.role === Roles.SRE;
export const selectPermissions = state => state.auth.permissions;
export const selectSRETenant = state => state.auth.SRETenant;
export const selectAuthError = state => state.auth.error;
export const selectAuthLoading = state => state.auth.isLoading;

export default authSlice.reducer;
